import {
  GET_FEE_NAME_LIST_SUCCESS,
  GET_FEE_NAME_LIST_FAILED,
  RESET_GET_FEE_NAME_LIST,
  LOADING_GET_FEE_NAME_LIST,
  NETWORK_ERROR_GET_FEE_NAME_LIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetFeeNameList = () => {
  return { type: RESET_GET_FEE_NAME_LIST };
};

const getFeeNameList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GET_FEE_NAME_LIST });
  await adminServices
    .post("getFeeNameList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getFeeNameListsuccess(res.data));
          break;
        default:
          dispatch(getFeeNameListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GET_FEE_NAME_LIST, payload: err });
    });
};
function getFeeNameListsuccess(data) {
  return {
    type: GET_FEE_NAME_LIST_SUCCESS,
    payload: data,
  };
}
function getFeeNameListFailed(data) {
  return {
    type: GET_FEE_NAME_LIST_FAILED,
    payload: data,
  };
}

export { resetGetFeeNameList, getFeeNameList };
